import React from "react";
import { InsightLiteDetailContainer } from "@containers/Insight/Lite";
// import Header from "@layouts/Main/lib/Header";
import { GetServerSideProps, NextPage } from "next";
import { InsightData } from "@repositories/insight/insight.redux";
import { useRouter } from "next/router";
import InsightServices from "@libraries/services/insight";
import axios, { AxiosResponse } from "axios";
import ButtonHelp from "@atoms/ButtonHelp";
import { NAVBAR_API } from "@libraries/repositories/navbar";
import { TProductIconData } from "@layouts/Main/lib/Header/lib/MenuProduct/type";
import { getInsightList } from "@libraries/api/insight-list/insight-list.repos";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { localeKey } from "@constants/locale-key";
// import { useMediaQuery, useTheme } from "@mui/material";

interface InsightDetailPageProps {
  data?: InsightData;
  dataNavbar: TProductIconData[];
  insightList: {
    data: InsightData[];
  };
}

const InsightDetail: NextPage<InsightDetailPageProps> & {
  getLayout?: (_page: React.ReactNode) => React.ReactNode;
} = ({ data, dataNavbar, insightList }) => {
  const router = useRouter();

  if (!data) {
    router.back();
    return null;
  }

  return (
    <InsightLiteDetailContainer
      data={data as InsightData & { keyword: string[] }}
      dataNavbar={dataNavbar}
      insightList={insightList}
    />
  );
};

InsightDetail.getLayout = (page) => {
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      {/* {isMobile ? null : <Header />} */}
      {page}
      <ButtonHelp />
    </>
  );
};

export const getServerSideProps: GetServerSideProps<InsightDetailPageProps> = async (context) => {
  const slug = `${context.query.slug}`;
  const lang = `${context.locale}`;

  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  );

  const apiConfig = InsightServices.getInsightDetail(slug, lang);

  const { data: insightDetail }: { data: AxiosResponse<InsightData> } = await axios(apiConfig);
  const { data: levelOneList } = await NAVBAR_API.GET_PRODUCT_MENU();
  const { data: dataInsightList } = await getInsightList({
    keyword: `${insightDetail.data?.keyword?.join(",")}`,
    slug: insightDetail.data?.slug,
  }, lang);

  const responseInsightList = JSON.parse(JSON.stringify(dataInsightList));

  if (!insightDetail.data || ["undefined", "null"].includes(slug) || !slug) {
    return {
      redirect: {
        destination: `/404`,
        permanent: false
      }
    };
  }

  if (Object.keys(insightDetail.data).length === 0) {
    return {
      redirect:{
        destination: `/404`,
        permanent: true
      }
    };
  }

  return {
    props: {
      ...(await serverSideTranslations(context.locale ?? "id", localeKey)),
      title: `${insightDetail.data?.title}`,
      data: insightDetail.data,
      description: `Lihat bagaimana MyTEnS membantu mengembangkan berbagai bisnis`,
      canonical: `${insightDetail.data?.canonical}`,
      dataNavbar: levelOneList,
      insightList: responseInsightList,
    },
  };
};

export default InsightDetail;
